<template>

    <div class="container-fluid">
        <div class="width100">
            <header class="header black-bg">

                <!--logo start-->
                <div id="top_menu" class="align-items-center">
                    <a v-if="logoClient!=''" href="#" class="logo">
                        <img  v-bind:src="logoClient" class="img-thumbnail">
                    </a>
                    <h3 v-else class="nomClient">{{nomClient}}</h3>
                    <h3 class="text-center brush">Maintenance</h3>
                </div>

            </header>

            <b-modal id="modalMDP" hide-footer @shown="focusMdp"
                     header-bg-variant="thtab"
                     header-text-variant="light">
                <template v-slot:modal-title>
                    Mot de passe {{user}}
                </template>
                <div class="d-block text-center">
                    <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
                        <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
                    </div>
                    <input type="password" v-model="mdp" ref="mdp" class="form-control" v-on:keyup.enter="connexion()">
                </div>
                <br/>
                <div class="row">
                    <div class="col-6 text-center">
                        <b-button class=" btn btn-danger" @click="$bvModal.hide('modalMDP')">Annuler</b-button>
                    </div>
                    <div class="col-6 text-center">
                        <b-button class=" btn btn-success" @click="connexion()">Valider</b-button>
                    </div>
                </div>
            </b-modal>

            <div v-if="token==null" class="solubacDiv row">
                <!--<div v-if="systemeClientId==1" class="row">-->
                    <div v-for="(userL, id) in listUser" :key="id" class="thtab userList col-4 text-center rounded brush" v-b-modal.modalMDP @click="modalMDP(userL.email,userL.roles[0],userL['@id'],userL['id'],userL.name)">
                        {{userL.name}}
                    </div>
                <!--</div>
                <div v-else-if="systemeClientId==2">
                    <p></p>
                    <searchAutoCompleteUser v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
                            v-bind:user="user" @input="inputD" @inputNom="inputNomD" @inputMail="inputMail"
                            @inputType="inputType"
                            v-bind:search="user" v-bind:systemeClientId="systemeClientId"
                    />
                </div>-->
            </div>


            <div v-else class="solubacDiv ">
                <toolbar :current-comp="currentComp" v-bind:userType="userType"
                          @refreshToken="refreshToken" v-bind:systemeClientId="systemeClientId"></toolbar>
                <br/>
                <h3 class="titreSolu text-center">{{user}}</h3>
                <div>
                    <component :is="currentComp" v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
                               v-bind:user="user" v-bind:userId="userId" v-bind:listUser="listUser" v-bind:idUser="idUser"
                               v-bind:userType="userType" v-bind:systemeClient="systemeClient" v-bind:systemeClientId="systemeClientId"
                               v-bind:ifAppli="ifAppli"
                               @token="refreshToken()" :key="componentKey"></component>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
    import {site, racine, dossier,systemeClientId,systemeClient} from './variables.js'
    import Maintenance from './components/Maintenance.vue';
    import Machine from './components/Machine.vue';
    import Tache from './components/Tache.vue';
    import Compte from './components/Compte.vue';
    import Statistique from './components/Statistique.vue';
    import MachineType from './components/MachineType';
    import Echeance from './components/Echeance.vue';
    import DeclarationChauffeur from './components/DeclarationChauffeur.vue';
    import CarteGrise from './components/CarteGrise.vue';
    import Absence from './components/Absence.vue';
    import User from './components/User.vue';
    import DeclarationCarburant from './components/DeclarationCarburant.vue';
    import SearchAutoCompleteUser from './components/SearchAutoCompleteUser.vue';
    import LavageRemorque from './components/LavageRemorque.vue';
    import CarteVehicule from './components/CarteVehicule.vue';
    import Protocole from './components/Protocole.vue';
    import Panne from './components/Panne.vue';
    import Toolbar from './components/Toolbar.vue';
    import {bus} from './main.js';

    export default {
        el: '#app',

        data() {
            return {
                currentComp: 'maintenance', user: null, idUser: null, mdp: null, token: null,userId:null,
                site: site, racine: racine, dossier: dossier,systemeClient: systemeClient,systemeClientId: systemeClientId,
                listUser: [], errors: [],listSystemeClient:[],systemClient:null,userType:2, componentKey: 0,
                logoClient:"",nomClient:"",ifAppli:0,userName:''
            };
        },
        methods: {
            inputD(input) {
                console.log(input)
                this.userId = input
                this.idUser = input
            },
            inputNomD(input) {
                console.log(input)
                this.user = input
            },
            inputMail(input) {
                console.log(input)
                this.userMail = input
            },
            inputType(input) {
                console.log(input)
                this.userType = input
                this.$bvModal.show('modalMDP')
            },
            modalMDP(userL,userType,id,idUser,userNom) {
                this.user = userNom
                this.userMail = userL
                this.userType = userType
                this.userId = id
                this.idUser = idUser
            },
            focusMdp() {

                this.$refs.mdp.focus();

            },
            connexion() {
                this.errors = []
                console.log(this.user + ' ' + this.mdp);
                console.log(dossier);

                fetch(this.racine+this.site + "api/login", {
                    method: 'POST',
                    headers: {'Content-Type': 'application/ld+json'},
                    body: "{\"password\":\"" + this.mdp + "\",\"email\":\"" + this.userMail + "\"}"
                })
                    .then(response => response.json())
                    .then(json => {
                        this.token = json['token']
                        console.log(json);
                        if(json['message']=="Invalid credentials.")
                        {
                            this.errors.push("Votre mot de passe n'est pas correct.");
                        }
                        else
                        {
                            this.$bvModal.hide('modalMDP')
                            this.errors = []
                            this.currentComp = 'maintenance'
                        }
                    })

            },
            refreshToken() {
                this.token = null
                this.mdp = null
                window.location.reload(true);
            },
            getListUser() {
                //alert(racine + site + "api/users?order[email]=asc&property[systemeClient]="+systemeClient)
                fetch(racine + site + "api/get_user_by_systeme_client/"+this.systemeClientId, {
                    method: 'GET',
                }).then(response => response.json())
                    .then(json => {
                        this.listUser = json['hydra:member']
                        this.logoClient = json['logoClient']
                        this.nomClient = json['nomClient']

                        console.log(json)
                        console.log(this.logoClient)
                        console.log(this.nomClient)

                    })
            },
            getSysteme() {
                //on cherche à récupérer le systeme qui est noté dans le fichier systemeClient.json présent dans le dossier
                const xhr = new XMLHttpRequest();
                var self = this
                if(window.cordova) {//si on est sur téléphone
                    self.getListUser()
                    this.ifAppli = 1
                }
                else
                {//si version navigateur, on récupère le fichier (présent dans le dossier) qui définit le client
                    xhr.onreadystatechange = () => {
                        if (xhr.readyState === 4) {
                            console.log(xhr.responseText);
                            var data = xhr.responseText;
                            console.log(data)
                            console.log(self.systemeClientId)
                            self.systemeClientId = data
                            self.systemeClient = self.site+"api/systeme_clients/"+self.systemeClientId
                            console.log(self.systemeClientId)
                            setTimeout(function () {
                                self.getListUser()
                            }, 100);
                        }
                    }
                    console.log(location.pathname+'libs/systemeClientProd.json')
                    xhr.open('GET', location.pathname+'libs/systemeClientProd.json', true);
                    xhr.send('');
                }

            }

        },
        created() {
            bus.$on('switchComp', comp => {
                this.currentComp = comp;
            })
            this.getSysteme()
            var self = this
            setTimeout(function () {
                self.refreshToken()
            }, 86400000);


        },

        components: {
            'maintenance': Maintenance,
            'toolbar': Toolbar,
            'machine': Machine,
            'tache': Tache,
            'compte': Compte,
            'statistique': Statistique,
            'machineType': MachineType,
            'echeance': Echeance,
            'declarationChauffeur': DeclarationChauffeur,
            'carteGrise': CarteGrise,
            'absence': Absence,
            'user': User,
            'searchAutoCompleteUser': SearchAutoCompleteUser,
            'declarationCarburant': DeclarationCarburant,
            'lavageRemorque': LavageRemorque,
            'carteVehicule': CarteVehicule,
            'protocole': Protocole,
            'panne': Panne,
        }
    }
</script>

<style>

    .brush {
        color:white;
        font-family: Revalia;
    }
    .userList {
        padding: 5px;
        /*margin-left: 2px;
        margin-right: 2px;
        margin-top: 5px;*/
        border:2px white solid;
        font-size: 28px;
    }
</style>


